import * as Sentry from '@sentry/nextjs';
import { sanitizeSentryEvent } from './sanitize';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const apiUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
const isReplayEnabled =
  process.env.NEXT_PUBLIC_SENTRY_REPLAY_ENABLED === 'true';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment:
      process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV,
    sampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE ?? 0.1),
    tracesSampleRate: Number(
      process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? 0.1
    ),
    tracePropagationTargets: apiUrl ? [apiUrl] : [],
    sendDefaultPii: false,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new Sentry.BrowserTracing(),
      ...(isReplayEnabled
        ? [
            new Sentry.Replay({
              maskAllText: true,
              maskAllInputs: true,
              blockAllMedia: false,
              networkDetailAllowUrls: apiUrl ? [apiUrl] : [],
            }),
          ]
        : []),
    ],
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      'ChunkLoadError',
      'Loading chunk',
      'Loading CSS chunk',
      /^Script error\.?$/,
    ],
    denyUrls: [
      /googletagmanager\.com/i,
      /google-analytics\.com/i,
      /connect\.facebook\.net/i,
      /heap(analytics)?\.com/i,
      /chrome-extension:\/\//i,
      /moz-extension:\/\//i,
    ],
    beforeSend: sanitizeSentryEvent,
  });
}
